module.exports = __webpack_public_path__ + "static/media/AdobeSign_Step3_Image27.89e7a7ab.webp";